import { getRecoilPromise } from "recoil-nexus";
import { apiPrefixState } from "atoms/apiPrefixState.atom";

export const getApiPrefix = () => {
  return new Promise(async (resolve) => {
    getRecoilPromise(apiPrefixState).then(function (apiPrefix) {
      resolve(apiPrefix);
    });
  });
};

export const getFieldMappingsForCustomerURL = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fieldmappings/fieldmapping");
  });
};

export const getFieldMappingsByName = async (name) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fieldmapping/name/" + name);
  });
};

export const getFieldMappingsByCustomerIdAndControlTypeURL = async (controlType) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fieldmapping/controltype/" + controlType);
  });
};

export const getFieldMappingsFromIdURL = async (id) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fieldmapping/" + id);
  });
};

export const getAddressByCoordinatesURL = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/address/coordinates");
  });
};

export const getPostCodeLookupURL = async (postcode, country) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/address/" + postcode + "/" + country);
  });
};

export const getAddressFromSuggestion = async (id) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/address/" + id);
  });
};

export const getFnolQuestionSet = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fnol/questionset");
  });
};

export const getOnFnolPropertyChange = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fnol/on-fnol-property-change");
  });
};

export const getRentalOrRepairerLookupListURL = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fnol/on-rental-or-repairer-lookup");
  });
};

export const getCreateFnolInstanceURL = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fnol");
  });
};

export const getFilteredDropdownByIdURL = async (id) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/dropdownoptions/" + id);
  });
};

export const getLookupTypeByNameURL = async (typeName) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/lookup/type/" + typeName);
  });
};

export const GetLookupsByTypeIdURL = async (typeId) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/lookup/" + typeId);
  });
};

export const getLookupValuesFromAutocompleteURL = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/lookup/autocomplete");
  });
};

export const GetCustomerByExtId = async (id) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/customer");
  });
};

export const getBusinessHierarchiesByCustomerId = async (customerId) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/business");
  });
};

export const getUploadFilesToFnolUrl = async (tempDocumentsId) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/file/" + tempDocumentsId);
  });
};

export const getCustomerTheme = async () => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/CustomerTheme");
  });
};

export const getCompleteFnolUrl = async (fnolId) => {
  let prefix = await getApiPrefix();
  return new Promise(async (resolve) => {
    resolve(prefix + "api/fnol/" + fnolId + "/complete");
  });
};
